import { createRoot } from "react-dom/client";
import NearbyPlaces from "./NearbyPlaces";

console.log("=== nearby-places/index.tsx loaded ===");

const root = document.getElementById("nearby-places-root");

console.log("Root element:", root);

if (root) {
  console.log("Mounting NearbyPlaces component...");
  createRoot(root).render(<NearbyPlaces />);
  console.log("NearbyPlaces component mounted!");
} else {
  console.error("ERROR: nearby-places-root element not found!");
}

export default NearbyPlaces;
